import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import {SxProps, Theme} from '@mui/material/styles';
import PrimaryButton from '../StyledComponents/PrimaryButton';
import {fonts, kit} from './tokens';

interface NotFoundPageProps {
  headline?: string;
  message?: string;
  actionLabel?: string;
  onAction: () => void;
  sx?: SxProps<Theme>;
}

// 404 page (web-sys-states.html #5): same voice as the rest of the kit --
// serif headline, one line of help, one way home. Self-contained so any
// route owner can drop it in as the catch-all; it does not assume any
// particular router.
const NotFoundPage = ({
  headline = "This page doesn't exist",
  message = 'The link may be old, or the page may have been removed.',
  actionLabel = 'Go to my projects',
  onAction,
  sx,
}: NotFoundPageProps) => (
  <Box
    sx={[
      {
        minHeight: '60vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: '48px 24px',
      },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}>
    <Typography
      sx={{
        fontFamily: fonts.serif,
        fontSize: 64,
        lineHeight: 1,
        letterSpacing: '0.06em',
        color: kit.line,
        fontWeight: 400,
        marginBottom: '14px',
      }}>
      4 0 4
    </Typography>
    <Typography
      sx={{
        fontFamily: fonts.serif,
        fontSize: 22.5,
        lineHeight: 1.25,
        color: kit.ink,
        fontWeight: 400,
      }}>
      {headline}
    </Typography>
    <Typography
      sx={{
        marginTop: '8px',
        maxWidth: 380,
        fontSize: 14.5,
        color: kit.slate,
        fontWeight: 500,
      }}>
      {message}
    </Typography>
    <Box sx={{marginTop: '22px'}}>
      <PrimaryButton onClick={onAction}>{actionLabel}</PrimaryButton>
    </Box>
  </Box>
);

export default NotFoundPage;
